export default __webpack_public_path__ + "static/media/banner_mob_rosa_2.54c278d6.jpg";